import { Box, Button, Stack } from "@mui/material";
import { Fragment, useState } from "react";
import PageHeader from "src/components/shared/PageHeader";
import SearchFilterComp from "src/components/shared/SearchFilterComp";
import SelectComp from "src/components/shared/SelectComp";
import TabComp from "src/components/shared/TabComp";
import TableComp from "src/components/shared/table/TableComp";
import FinanceStaticstic from "./FinanceStaticstic";
import useAllFinanceAction from "./utils/useAllFinanceAction";
import useAllFinanceBody from "./utils/useAllFinanceBody";
import useAuthGlobal from "src/context/useAuthGlobal";
import { userRoleType } from "src/constant";
const tabs = [
  {
    id: "Paid",
    name: "Đã thanh toán công nợ",
  },
  {
    id: "Unpaid",
    name: "Chưa thanh toán công nợ",
  },
  {
    id: "Draft",
    name: "Lịch sử  thanh toán công nợ",
  },
];
export default function SummaryFinancePage() {
  const { userMe } = useAuthGlobal();
  const [sumWhouseId, setSumWHouseId] = useState();
  const queryParams = new URLSearchParams(window.location.search);
  const tabParams = queryParams.get("tab");
  const currentTab = tabs.find((tab) => tab.id === tabParams);
  const subName = currentTab?.name || "Xuất chuyển/kho";
  const [, setSearchKey] = useState();
  const [, setSearchBy] = useState();
  const [wHouseId, setWHouseId] = useState();
  const { header, bodyList, isLoading, sortData } = useAllFinanceBody({ wHouseId });
  const action = useAllFinanceAction({ wHouseId });

  const handleExport = () => {
    console.log("first");
  };

  return (
    <Fragment>
      <PageHeader
        name="Quản lý Công nợ"
        subName={subName}
        value={sumWhouseId}
        setValue={setSumWHouseId}
        item={{ path: "/api/v1/warehouses", params: { limit: 100, skip: 0 } }}
        userMe={userMe}
      />
      <FinanceStaticstic />

      <Stack
        gap={1.5}
        mb={1.5}
      >
        <TabComp tabs={tabs} />
        <Box
          display="flex"
          gap="6px"
          justifyContent="space-between"
        >
          <SearchFilterComp
            selectList={[]}
            getSearchKeyword={setSearchKey}
            getSelectKeyword={setSearchBy}
          />
          <Box
            display="flex"
            gap="12px"
            sx={{ width: "30%" }}
          >
            <SelectComp
              setValue={setWHouseId}
              value={wHouseId}
              label="Kho"
              item={{ path: "/api/v1/warehouses", params: { limit: 100, skip: 0 } }}
              disabled={userMe?.role?.name !== userRoleType.superAdmin}
            />
            <Button
              fullWidth
              sx={{
                whiteSpace: "nowrap",
                // maxWidth: "180px",
                // width: "100%",
                height: "36px",
              }}
              onClick={() => alert("Đang trong quá trình phát triển ...")}
              variant="contained"
            >
              Thanh toán hàng loạt
            </Button>
            <Button
              fullWidth
              sx={{
                whiteSpace: "nowrap",
                maxWidth: "130px",
                width: "100%",
                height: "36px",
              }}
              onClick={handleExport}
              variant="contained"
            >
              Xuất BC công nợ
            </Button>
          </Box>
        </Box>
      </Stack>

      <TableComp
        action={action}
        headers={header}
        bodyList={bodyList}
        sortData={sortData}
        isLoading={isLoading}
      />
    </Fragment>
  );
}
